import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

export default function GallaryProductEdit() {
    const history = useNavigate();

  const [file15, setFile15] = useState(null);
  const [inputval14, setInputVal14] = useState({
    GallaryProductimg:"",
    fname15: "",
    date: "",
  });

  const setData = (e) => {
    const { name, value } = e.target;
    setInputVal14((Data) => {
      return {
        ...Data,
        [name]: value,
      };
    });
  };
  const { id } = useParams("");
  console.log(id);
  const getData = async () => {
    const res14 = await fetch(`https://pratik-agro-backend.vercel.app/getGallaryProductimg/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data3 = await res14.json();

    if (res14.status === 422 || !data3) {
      console.log("error");
    } else {
      console.log(data3);
    setInputVal14({
        GallaryProductimg: data3.GallaryProductimg,
      fname15: data3.fname15,
      date: data3.date,
    });
  }
  };
  useEffect(() => {
    getData();
  }, []);

  const updateData8 = async (e) => {
    e.preventDefault();

    console.log(inputval14);

    var formData15 = new FormData();
    if (file15 != null) {
      formData15.append("image15", file15);
    }
    formData15.append("fname15", inputval14.fname15);
    formData15.append("date", inputval14.date);

    for (var pair of formData15.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(`https://pratik-agro-backend.vercel.app/updateGallaryProductimg/${id}`, formData15, config)
      .then((res) => {
        if (res.status === 201) {
          console.log(res.data);
          history("/GallaryProduct");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
      });
  };
  return (
    <div className='content'>
         <div className="container mt-5 ">
          <Link className="btn btn-dark" to="/GallaryProduct">
          <i class="bi bi-arrow-left-circle-fill"></i>
          </Link>
        </div>

        <form className="mx-auto mt-5 shadow p-5">
          <div className="container ">
            <h6>Fill This Form:-</h6>
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label"> ProductImage :</label>
            <input
              type="file"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="image15"
              onChange={(e) => setFile15(e.target.files[0])}
              value={inputval14.image15}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label"> ProductImage Name: :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="fname15"
              onChange={setData}
              value={inputval14.fname15}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Date:</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="date"
              onChange={setData}
              value={inputval14.date}
            />
          </div>
          <div>
            <Link className="btn btn-success  mt-3" onClick={updateData8}>
              update Detail
            </Link>
          </div>
        </form>
    </div>
  )
}